import { Lexer } from '../parsing/lexer';
import { TokenType } from '../parsing/token';
// Remove old headers from persisted modules as well as newly parsed filters.
// Use token positions so a matching string literal is never removed.
export var stripSiteMetadata = function (text) {
    var result = text.trim().replaceAll('\r', '');
    var lines = result.split('\n');
    var offsets = [];
    var offset = 0;
    for (var _i = 0, lines_1 = lines; _i < lines_1.length; _i++) {
        var line = lines_1[_i];
        offsets.push(offset);
        offset += line.length + 1;
    }
    var tokens = new Lexer(result)
        .tokenize()
        .filter(function (token) {
        return token.type === TokenType.COMMENT &&
            token.value.startsWith('/*@ define:sitemeta');
    });
    for (var _a = 0, _b = tokens.reverse(); _a < _b.length; _a++) {
        var token = _b[_a];
        var start = offsets[token.location.line - 1] + token.location.char - 1;
        result =
            result.slice(0, start) + result.slice(start + token.value.length);
    }
    return result;
};
